var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.333 13.833V9.667h3.333v4.166c0 .459.375.834.834.834H13a.836.836 0 00.833-.834V8h1.417c.383 0 .566-.475.275-.725L8.558 1a.84.84 0 00-1.117 0L.475 7.275A.415.415 0 00.75 8h1.417v5.833c0 .459.375.834.833.834h2.5a.836.836 0 00.833-.834z",
    fill: "#fff"
  })));
}
export default SvgHome;